import { useState } from 'react';
import { Player } from '@remotion/player';
import { useTranslation } from 'react-i18next';
import Layout from '@/components/Layout';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { MotionTestComposition } from '@/remotion/MotionTestComposition';
import { motionExamples } from '@/lib/motion/examples';
import { EXPORT_FPS } from '@/lib/timeline/exportFrameTiming';

export const MotionTest = () => {
  const { t } = useTranslation();
  const [selected, setSelected] = useState(motionExamples[0].id);
  const example = motionExamples.find((item) => item.id === selected) ?? motionExamples[0];
  return (
    <Layout>
      <div className="mx-auto w-full max-w-6xl space-y-6 p-6">
        <h1 className="text-2xl font-semibold">{t('motionGallery.title')}</h1>
        <div className="flex flex-wrap gap-2" aria-label={t('motionGallery.examples')}>
          {motionExamples.map((item) => (
            <Button key={item.id} variant={selected === item.id ? 'default' : 'outline'}
              onClick={() => setSelected(item.id)} aria-pressed={selected === item.id}>
              {t(`motionGallery.names.${item.id}`, { defaultValue: item.name })}
            </Button>
          ))}
        </div>
        <div className="grid items-start gap-6 md:grid-cols-[minmax(0,1fr)_minmax(0,1fr)]">
          <Card><CardContent className="p-3">
            <Player key={example.id} component={MotionTestComposition} inputProps={{ scene: example.scene }}
              durationInFrames={6 * EXPORT_FPS} fps={EXPORT_FPS} compositionWidth={1080} compositionHeight={1920}
              controls loop style={{ width: '100%', maxHeight: '70vh' }} />
          </CardContent></Card>
          <pre className="max-h-[70vh] overflow-auto rounded-lg border bg-muted p-4 text-xs" tabIndex={0}
            aria-label={t('motionGallery.scene')}>
            {JSON.stringify(example.scene, null, 2)}
          </pre>
        </div>
      </div>
    </Layout>
  );
};
